import React, { useCallback } from "react";
import { Grid } from "@material-ui/core";
import { Header } from "../../Components";
import { AdministrationSidebar } from "./Components/AdministrationSidebar/index";
import { Customer } from "./Features/Customer";
import {
  ModuleContext,
  useModule,
} from "../../Context/ModuleContext/ModuleContext";
import { useStyles } from "../Module.styles";
import clsx from "clsx";
import { UserListCustomer } from "./Features/Users/UserList";
import { FormCustomer } from "./Features/Customer/FormCustomer";
import { UpdateFormCustomer } from "./Features/Customer/UpdateFormCustomer";
import { ClientUpdateForm } from "./Features/Customer/ClientUpdateForm";
import { useParams } from "react-router-dom";
import { TabTitle } from "../../Utilities";
import CustomerUserInvite from "./Features/Customer/CustomerUserInvite";
export const AdministrationModule = () => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleSidebarToggle = useCallback((open: boolean) => {
    setOpen(open);
  }, []);
  const param = useParams();
  const { name } = param;
  const { Provider } = ModuleContext;
  const module = useModule();
  TabTitle(name);
  return (
    <Grid container className="customer-page-container">
      <Grid item>
        <AdministrationSidebar
          sidebarOpen={open}
          handleSidebarToggle={handleSidebarToggle}
        />
      </Grid>
      <Grid
        item
        className={clsx(classes.content, {
          [classes.contentShift]: open,
        })}
      >
        <Provider value={module}>
          <Header
            sidebarOpen={open}
            handleSidebarToggle={handleSidebarToggle}
            title={name}
          />

          {name == "users" && <UserListCustomer />}
          {name == "customers" && <Customer />}
          {name == "customer" && <FormCustomer />}
          {name == "update-form" && <UpdateFormCustomer />}
          {name == "client-update-form" && <ClientUpdateForm />}
          {name == "invite" && <CustomerUserInvite />}
        </Provider>
      </Grid>
    </Grid>
  );
};
export default AdministrationModule;
